module.exports = __webpack_public_path__ + "img/0-1years.24ac96b5.svg";